<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import { refreshTokenHandler } from '@/utils/commonService';
import { calcDate, getURLSearchParams } from '@/utils/index.js';
import { IS_MOCK_KEY } from '@/utils/const';
import '@/sdk/vrAppJsSdk/main.js';
import platform from '@/utils/platform';
import { getDomain } from '@/api/commonApi';
export default {
  data() {
    return {};
  },
  created() {
    // 是否使用mock数据
    const { isMock } = getURLSearchParams();
    if (isMock) {
      window.sessionStorage.setItem(IS_MOCK_KEY, '1');
    } else {
      window.sessionStorage.removeItem(IS_MOCK_KEY);
    }
    this.onInit();
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        const res = await getDomain();
        if (res.code == 200 && res.data) {
          sessionStorage.setItem('domainUrl', res.data);
        }
      } catch (e) {
        console.log(e);
      }
    });
  },
  methods: {
    async onInit() {
      try {
        // 判断是小程序还是app，对应执行不同的初始化,默认小程序
        let config = {};
        if (platform.isOneWO) {
          config = {
            app: {},
          };
        } else {
          config = {
            wechat: {},
          };
        }
        const res = await window.vrapp.init(config);
        console.log('初始化成功', res);
      } catch (e) {
        console.log('初始化失败', e);
      }
    },
  },
};
</script>
<style lang="scss">
#app {
  font-size: 14px;
  width: 100vw;
  height: 100vh;
  background: #f9f9f9;
}
</style>
